import { IFormQuestion, IFormTypeDetail } from '../interfaces/form-type.interface';
import { FormTypeDto } from './form-type.dto';

export class FormTypeDetailDto extends FormTypeDto implements IFormTypeDetail {
  questions!: IFormQuestion[];
}
